import type { SelfOwnedWidgetDefinition } from '../WidgetDefinition';
import { faNoteSticky } from '@fortawesome/pro-duotone-svg-icons/faNoteSticky';
import type { NotepadWidgetModel } from 'src/models/NotepadWidgetModel';
import { NotepadWidgetModelImpl } from 'src/models/NotepadWidgetModel/impl';
import type { NotepadWidgetState } from 'src/models/NotepadWidgetModel/NotepadSelfOwnedModel';

export const notepadWidgetDefinition: SelfOwnedWidgetDefinition<NotepadWidgetState, NotepadWidgetModel> = {
    type: 'notepad' as const,
    nameKey: 'widgets::notepad::name' as const,
    roles: ['widgets::notepad'],
    icon: faNoteSticky,
    category: 'widgets::categories::misc' as const,
    defaultDimensions: { h: 0.4, w: 0.3, x: 0.35, y: 0.3 },
    isLocalOnly: true,
    widgetClass: NotepadWidgetModelImpl,
};
